import { Route } from 'react-router-dom';

import Layout from './Layout';

import SellerRoutes from './Seller/routes';
import DelegationRoutes from './Delegation/routes';
import NegotiationStatusRoutes from './NegotiationStatus/routes';
import PlayerRoutes from './Player/routes';
import PumpRoutes from './Pump/routes';
import AffiliateRoutes from './Affiliate/routes';
import AffiliateTraitRoutes from './AffiliateTrait/routes';
import AffiliatePumpRoutes from './AffiliatePump/routes';
import ApprovalAuthorityRoutes from './ApprovalAuthority/routes';
import ApprovalMarginRoutes from './ApprovalMargin/routes';
import HierarchyTraitRoutes from './HierarchyTrait/routes';
import HierarchyPumpRoutes from './HierarchyPump/routes';
import HierarchyPaymentRoutes from './HierarchyPayment/routes';
import CadFckBrSlRoutes from './CadFckBrSl/routes';
import PricePerDistanceRoutes from './PricePerDistance/routes';
import ConsumptionRoutes from './Consumption/routes';
import OwnConsumptionRoutes from './OwnConsumption/routes';
import FactorRoutes from './Factor/routes';
import ParameterRoutes from './Parameter/routes';
import RegionalEfficiencyRoutes from './RegionalEfficiency/routes';
import WorkOvertimeRoutes from './WorkOvertime/routes';
import PaymentRoutes from './Payment/routes';
// import ProposalRoutes from './Proposal/routes';
import RecommendationRoutes from './Recommendation/routes';
import SpectraRoutes from './Spectra/routes';
// import PricesRuleRoutes from './PricesRule/routes';
// import PricesContractRoutes from './PricesContract/routes';
// import PricesServiceRoutes from './PricesService/routes';
// import ManualRoutes from './Manual/routes';
// import UpdateNegotiationStatusRoutes from './UpdateNegotiationStatus/routes';

export default function BackOfficeRoutes() {
  return (
    <Route path="backoffice" element={<Layout />}>
      {/* <Route index element={<div>Backoffice Home</div>} /> */}
      {SellerRoutes()}
      {DelegationRoutes()}
      {NegotiationStatusRoutes()}
      {PlayerRoutes()}
      {PumpRoutes()}
      {AffiliateRoutes()}
      {AffiliateTraitRoutes()}
      {AffiliatePumpRoutes()}
      {ApprovalAuthorityRoutes()}
      {ApprovalMarginRoutes()}
      {HierarchyTraitRoutes()}
      {HierarchyPumpRoutes()}
      {HierarchyPaymentRoutes()}
      {CadFckBrSlRoutes()}
      {ConsumptionRoutes()}
      {OwnConsumptionRoutes()}
      {FactorRoutes()}
      {ParameterRoutes()}
      {RegionalEfficiencyRoutes()}
      {WorkOvertimeRoutes()}
      {PaymentRoutes()}
      {/* {ProposalRoutes()} */}
      {RecommendationRoutes()}
      {SpectraRoutes()}
      {PricePerDistanceRoutes()}
      {/* {PricesRuleRoutes()}
      {PricesContractRoutes()}
      {PricesServiceRoutes()}
      {ManualRoutes()}
      {UpdateNegotiationStatusRoutes()} */}
      <Route path="*" element={<h1>Página não encontrada</h1>} />
    </Route>
  );
}
